import React from 'react';

import {
  CustomizedButton,
  CustomizedDialog,
  CustomizedTypography
} from '@components/Customized';

import { Grid } from '@material-ui/core';
import { DeleteOutlined } from '@material-ui/icons';

import { UploadedDrawingFileType } from '@modules/request';

interface Props {
  selectedFileInfo: UploadedDrawingFileType | undefined;
  open: boolean;
  onClose: () => void;
  handleDeleteRfqFile: (payload: UploadedDrawingFileType) => void;
}
const DeleteDrawingFileDialog = ({
  selectedFileInfo,
  open,
  onClose,
  handleDeleteRfqFile
}: Props) => {
  return (
    <CustomizedDialog
      title="도면항목 삭제하기"
      icon={<DeleteOutlined />}
      color="error"
      open={open}
      onClose={onClose}
      borderRadius={8}
      closeButton
    >
      <CustomizedTypography
        variant="h4"
        color="textPrimary"
        fontWeight="500"
        gutterBottoms={12}
      >
        "{selectedFileInfo?.fileName}" 도면 항목을 삭제하시겠습니까?
      </CustomizedTypography>
      <CustomizedTypography
        variant="body2"
        color="textSecondary"
        gutterBottoms={32}
      >
        삭제한 도면 항목은 다시 불러올 수 없습니다.
      </CustomizedTypography>

      <Grid container spacing={1}>
        <Grid item xs={6}>
          <CustomizedButton
            color="secondary"
            fullWidth
            variant="contained"
            size="large"
            onClick={onClose}
          >
            취소하기
          </CustomizedButton>
        </Grid>
        <Grid item xs={6}>
          <CustomizedButton
            color="error"
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              handleDeleteRfqFile({ ...selectedFileInfo });
              onClose();
            }}
          >
            삭제하기
          </CustomizedButton>
        </Grid>
      </Grid>
    </CustomizedDialog>
  );
};

export default DeleteDrawingFileDialog;
